import { applyMiddleware, combineReducers, compose, createStore, Store } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { rootSaga } from './rootSaga';
import {
  offer,
  dictionaries,
  user,
  savedOffer,
  abExperiments,
  publishTerms,
  billingStatus,
  betPosition,
  fairPlay,
  checkoutInfo,
  auction,
  topBets,
  coworkingCombinedReducer,
  calltracking,
  publishInfo,
  publishAvailable,
  visibleViolations,
  config,
} from './reducers';
import { IAppState, ISagaContext } from './types';

let store: Store<IAppState>;

export function initStore(context: ISagaContext) {
  const initialState = window.__addform_data__ || {};

  const rootReducer = combineReducers<IAppState>({
    offer,
    dictionaries,
    savedOffer,
    user,
    abExperiments,
    publishTerms,
    billingStatus,
    betPosition,
    fairPlay,
    checkoutInfo,
    auction,
    topBets,
    coworking: coworkingCombinedReducer,
    calltracking,
    publishInfo,
    publishAvailable,
    visibleViolations,
    config,
  });

  const sagaMiddleware = createSagaMiddleware({ context });

  // istanbul ignore next
  const composeEnhancers = typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

  store = createStore(rootReducer, initialState, composeEnhancers(applyMiddleware(sagaMiddleware)));

  sagaMiddleware.run(rootSaga);
}

export const getStore = () => {
  if (!store) {
    throw new Error('Redux не инициализирован');
  }

  return store;
};
